import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import getPageTitle from "@/utils/pageTitle";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home,
  },
  {
    path: "/resource",
    meta: {
      title: "资源/服务中心",
    },
    component: () => import("../views/Resource.vue"),
  },
  {
    path: "/company",
    meta: {
      title: "公司",
    },
    component: () => import("../views/Company.vue"),
  },
  {
    path: "/about",
    meta: {
      title: "关于迈德米斯",
    },
    component: () => import("../views/About.vue"),
  },
  {
    path: "/industry-application",
    meta: {
      title: "行业应用",
    },
    component: () => import("../views/IndustryApplication.vue"),
  },
  {
    path: "/product-manual",
    meta: {
      title: "产品手册下载",
    },
    component: () => import("../views/ProductManual.vue"),
  },
  {
    path: "/products",
    meta: {
      title: "产品",
    },
    component: () => import("../views/Products.vue"),
  },
  {
    path: "/products/:name",
    meta: {
      title: "产品",
    },
    component: () => import("../views/ProductsName.vue"),
  },
  {
    path: "/product/:name",
    meta: {
      title: "产品",
    },
    component: () => import("../views/Product.vue"),
  },
  {
    path: "/purchase",
    component: () => import("../views/Purchase.vue"),
  },
  {
    path: "/media/:name",
    meta: {
      title: "视频和直播",
    },
    component: () => import("../views/Video.vue"),
  },
  {
    path: "/medias",
    meta: {
      title: "视频和直播",
    },
    component: () => import("../views/Videos.vue"),
  },
  {
    path: "/contact",
    meta: {
      title: "联系我们",
    },
    component: () => import("../views/Contact.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeResolve(async (to, from, next) => {
  document.title = getPageTitle(to.meta.title);
  next()
});

export default router;
